import { config } from "../core/config";
import type { Unsubscribe } from "../domain/types";
export async function subscribe(
  channel: string,
  events: Record<string, (data: unknown) => void>,
  connection?: (state: string) => void,
): Promise<Unsubscribe> {
  if (config.mock) {
    const { mockEvents } = await import("./mock");
    const handlers = Object.entries(events).map(([name, fn]) => {
      const handler = (e: Event) => fn((e as CustomEvent).detail);
      mockEvents.addEventListener(`${channel}:${name}`, handler);
      return [name, handler] as const;
    });
    connection?.("connected");
    return () =>
      handlers.forEach(([name, fn]) =>
        mockEvents.removeEventListener(`${channel}:${name}`, fn),
      );
  }
  if (!config.pusherKey) {
    connection?.("unavailable");
    throw new Error("configuration");
  }
  const { default: Pusher } = await import("pusher-js");
  const pusher = new Pusher(config.pusherKey, {
    cluster: "sa1",
    forceTLS: true,
  });
  const ch = pusher.subscribe(channel);
  Object.entries(events).forEach(([name, fn]) => ch.bind(name, fn));
  const state = ({ current }: { current: string }) => connection?.(current);
  pusher.connection.bind("state_change", state);
  return () => {
    ch.unbind_all();
    pusher.unsubscribe(channel);
    pusher.connection.unbind("state_change", state);
    pusher.disconnect();
  };
}
